import React from 'react';

var _path;

var SvgRiskMajor = function SvgRiskMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m1.16 16.829 7.498-15c.553-1.106 2.13-1.106 2.683 0l7.498 15A1.5 1.5 0 0 1 17.498 19H2.502a1.5 1.5 0 0 1-1.342-2.171zM10 7a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm1 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
  })));
};

export { SvgRiskMajor as S };
